import { FeaturesSettings } from './feature-settings';

export const SiteFeature: Record<string, keyof FeaturesSettings> = {
  SfccBasket: 'SfccBasket',
  SfccBasketEngraving: 'SfccBasketEngraving',
  SfccBasketLocationWarning: 'SfccBasketLocationWarning',
  SfccBasketSendByEmail: 'SfccBasketSendByEmail',
  SfccBasketShippingMessage: 'SfccBasketShippingMessage',
  SfccPrice: 'SfccPrice',
  SfccBasketGiftWrapping: 'SfccBasketGiftWrapping',
  SfccSearch: 'SfccSearch',
  BasketUipEnabled: 'BasketUipEnabled',
  TopMenuUipEnabled: 'TopMenuUipEnabled',
  TopMenuMyJabraEnabled: 'TopMenuMyJabraEnabled',
  ProductVisualizationRendering: 'ProductVisualizationRendering',
  Klarna: 'Klarna',
};
